/* tslint:disable */
/* eslint-disable */
/**
 * Tenants API
 * API for managing tenants
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchTenantCheckoutDateCommand
 */
export interface PatchTenantCheckoutDateCommand {
    /**
     * Date calendaire "yyyy-MM-dd" — sans heure ni offset
     * @type {string}
     * @memberof PatchTenantCheckoutDateCommand
     */
    checkOutDate?: string;
}

/**
 * Check if a given object implements the PatchTenantCheckoutDateCommand interface.
 */
export function instanceOfPatchTenantCheckoutDateCommand(value: object): value is PatchTenantCheckoutDateCommand {
    return true;
}

export function PatchTenantCheckoutDateCommandFromJSON(json: any): PatchTenantCheckoutDateCommand {
    return PatchTenantCheckoutDateCommandFromJSONTyped(json, false);
}

export function PatchTenantCheckoutDateCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchTenantCheckoutDateCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'checkOutDate': json['checkOutDate'] == null ? undefined : json['checkOutDate'],
    };
}

export function PatchTenantCheckoutDateCommandToJSON(json: any): PatchTenantCheckoutDateCommand {
    return PatchTenantCheckoutDateCommandToJSONTyped(json, false);
}

export function PatchTenantCheckoutDateCommandToJSONTyped(value?: PatchTenantCheckoutDateCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkOutDate': value['checkOutDate'],
    };
}

